import uly from "ulysses/base";
import $ from "jquery";
import ko from "knockout";
import HalResource from "ulysses/api";
import boxhtml from "ulysses/box.html";
import "ulysses/controls/textinput";

"use strict";
uly.actions = $.extend(uly.actions, {
    get_search_model_from_context: function get_search_model_from_context(context) {
        var stack = context.$parents;
        for (var i in stack) {
            if (i > 2) {
                return null;
            }
            
            var c = stack[i];
            if (c.search_model) {
                return ko.unwrap(c.search_model);
            } else if (c.get_search_configuration) {
                return c;
            }
        }
        return null;
    },
    get_search_settings_from_context: function get_search_settings_from_context(context) {
        var stack = context.$parents;
        var found_search_model = false;
        for (var i in stack) {
            if (i > 3) {
                return null;
            }
            
            var c = stack[i];
            if (c.search_model) {
                return ko.unwrap(c.search_settings) || ko.unwrap(c.settings);
            } else if (found_search_model) {
                if (c.search_settings || c.settings ) {
                    return ko.unwrap(c.search_settings) || ko.unwrap(c.settings);
                }
            } else if (c.get_search_configuration) {
                found_search_model = true;
            }
        }
        return null;
    },
    get_search_widget_from_context: function get_search_settings_from_context(context) {
        var stack = context.$parents;
        var found_search_model = false;
        for (var i in stack) {
            if (i > 3) {
                return null;
            }
            
            var c = stack[i];
            if (c.search_model) {
                return c;
            } else if (found_search_model) {
                if (c.search_settings || c.settings ) {
                    return c;
                }
            } else if (c.get_search_configuration) {
                found_search_model = true;
            }
        }
        return null;
    },
    bulk_action: function(ev, $elt, ui) {
        if (!ui.selected){
            return uly.actions.standard_action(ev, $elt, ui);
        }
        var entity_model = ui.selected;
        var action_resource = HalResource(ui.model);
        var def = Promise.Deferred();
        var search = null;
        var search_model = uly.actions.get_search_model_from_context(ui.context);
        if(search_model) {
            var s = search_model.pager.selection.all_selected();
            if (s) {
                search = search_model.get_search_configuration();
            }
        }
        if (search) search = ko.toJSON(search);

        var selection = ko.unwrap(ui.selected);
        if (Array.isArray(selection)) {
            selection = $.map(selection, function(val) {
                return ko.unwrap(val.unique_id) || ko.unwrap(val.id);
            });
        } else selection = ko.toJSON(selection);

        action_resource.done(function(action_model) {
            ui.model = action_model;
            var epic_id = action_model.epic ? uly.utils.generate_epic_id() : null;
            var has_dialog = ko.unwrap(ui.model.has_dialog) || false;
            if (has_dialog) {
                action_resource.get_uri("uly:dialog").done(function(uri) {
                    uly.dialogs.show(uri, {
                        epic_id: epic_id,
                        before_close : function(result, button_pressed){
                            var post_data = $.extend({}, result, {
                                    "button_pressed":button_pressed,
                                    "epic_id": epic_id
                            });
                            return action_resource.post("uly:submit", post_data)
                        }
                    },{
                        "selected": selection,
                        "search_selection": search
                    }).then(function([result, uidata, button, info]) {
                        try {
                            if (ko.isObservable(ui.selected))
                                ui.selected([]);
                                if(search_model) {
                                    search_model.pager.clear_selection();
                                }
                        } catch (e) {
                        }
                        def.resolve(result);
                        uly.publish("entity.modified", { "entities":entity_model });
                        uly.utils.maybe_redirect(result);
                    }, function(result) {
                        def.reject(result);
                        uly.utils.show_results(result);
                    });
                }).fail(function(error) {
                    def.reject(error);
                    uly.utils.show_results(error);
                });
            } else {
                if (epic_id) uly.dialogs.progress_epic(action_model.caption, epic_id);
                action_resource.post("uly:submit", {
                    "selected": selection,
                    "search_selection": search,
                    "epic_id": epic_id
                }).done(function(result) {
                    if (epic_id && !result.wait_for_epic) {
                        uly.publish("socket.epic.progress."+epic_id, {"progress":100, "finished":true});
                    } else if (result.wait_for_epic) {
                        if (!epic_id) {
                            uly.dialogs.progress_epic(action_model.caption, result.wait_for_epic);
                        } else if (result.wait_for_epic != epic_id) {
                            uly.publish("socket.epic.progress."+epic_id, {"progress":100, "finished":true});
                            uly.dialogs.progress_epic(action_model.caption, result.wait_for_epic);
                        }
                    }

                    try {
                        if (ko.isObservable(ui.selected))
                            ui.selected([]);
                    } catch (e) {
                    }
                    def.resolve(result);
                    uly.publish("entity.modified", { "entities":entity_model });
                    uly.utils.maybe_redirect(result);
                }).always(uly.utils.show_results);
            }
        }).fail(def.reject);
        return def;
    },
    standard_action: function(ev, $elt, ui) {
        var action_resource = HalResource(ui.model);
        var def = Promise.Deferred();
        action_resource.done(function(action_model) {
            ui.model = action_model;
            var has_dialog = ko.unwrap(ui.model.has_dialog) || false;
            var dialog_data = {};
            var ids = uly.actions.get_standard_ids(ev, $elt, ui);
            var entity_model = ui.entity_model ? ui.entity_model : uly.utils.get_bound_entity($elt);
            if (entity_model && !Array.isArray(entity_model)) {
                entity_model = [entity_model];
            }
            var epic_id = action_model.epic ? uly.utils.generate_epic_id() : null;
            var search = null;
            if (action_model.accept_search) {
                var search_model = uly.actions.get_search_model_from_context(ui.context);
                if(search_model) {
                    search = search_model.get_search_configuration();
                }
            }

            if (has_dialog) {
                action_resource.get_uri("uly:dialog", {"id":ids[0]}).done(function(uri) {
                    uly.dialogs.show(uri, {
                        epic_id: epic_id,
                        before_close : function(result, button_pressed){
                            var post_payload = {
                                    "button_pressed":button_pressed,
                                    "epic_id": epic_id
                            }
                            if (search) post_payload = $.extend(post_payload, {"search": search});
                            var post_data = $.extend({}, result, post_payload);

                            var res = action_resource.post("uly:submit", post_data);
                            return res.then(function(data){
                                if (data.download_location) {
                                    window.open(data.download_location, "_blank");
                                }
                                if (data.redirect) {
                                    uly.utils.ask_for_redirect(data);
                                    return {};
                                }
                                return data;
                            });
                        }
                    },{
                        "entities":ids
                    }).then(([result, ui, button_pressed, server_result]) => {

                        if (epic_id && !server_result.wait_for_epic) {
                            uly.publish("socket.epic.progress."+epic_id, {"progress":100, "finished":true});
                        } else if (server_result.wait_for_epic) {
                            let new_epic = server_result.wait_for_epic === true ? server_result.epic_id : server_result.wait_for_epic;
                            if (!new_epic) {
                                new_epic = epic_id;
                            }
                            if (!epic_id) {
                                uly.dialogs.progress_epic(action_model.caption, new_epic);
                            } else if (new_epic != epic_id) {
                                uly.publish("socket.epic.progress."+epic_id, {"progress":100, "finished":true});
                                uly.dialogs.progress_epic(action_model.caption, new_epic);
                            }
                        }

                        def.resolve(result);
                        uly.publish("entity.modified", { "entities":entity_model});
                        uly.utils.maybe_redirect(server_result);
                    }, (result) => {
                        def.reject(result);
                        uly.utils.show_results(result);
                    });
                }).fail(function(error) {
                        def.reject(error);
                    uly.utils.show_results(error);
                });
            } else {
                if (epic_id) uly.dialogs.progress_epic(action_model.caption, epic_id);
                var post_data = { "selected":ids, "epic_id": epic_id };
                if (ui.post_data) {
                    post_data = Object.assign(post_data, ui.post_data);
                }
                if (search) post_data = $.extend(post_data, {"search": search});

                action_resource.post("uly:submit", post_data).then(function(result) {
                    //race condition here on staleness. the websocket update may have come down earlier.
                    //what should we do?
                    if (epic_id && !result.wait_for_epic) {
                        uly.publish("socket.epic.progress."+epic_id, {"progress":100, "finished":true});
                    } else if (result.wait_for_epic) {
                        if (!epic_id) {
                            uly.dialogs.progress_epic(action_model.caption, result.wait_for_epic);
                        } else if (result.wait_for_epic != epic_id) {
                            uly.publish("socket.epic.progress."+epic_id, {"progress":100, "finished":true});
                            uly.dialogs.progress_epic(action_model.caption, result.wait_for_epic);
                        }
                    }
                    def.resolve(result);
                    uly.publish("entity.modified", { "entities":entity_model});
                    uly.utils.maybe_redirect(result);
                    return result;
                }).always(uly.utils.show_results);
            }
        }).fail(def.reject);
        return def;
    },
    create_entity_action: function(ev, $elt, ui) {
        var action_resource = HalResource(ui.model);
        var def = Promise.Deferred();
        var control_id = uly.utils.find_in_context(ui.context || $elt, function(ctx) { return ko.unwrap(ctx.control_id); });
        action_resource.done(function(action_model) {
            ui.model = action_model;
            var has_dialog = ko.unwrap(ui.model.has_dialog) || false;
            var dialog_data = {};

            var action = ui.model;
            var search = null;
            if (action.accept_search) {

                console.log("Loading search", ui);
                var search_model = uly.actions.get_search_model_from_context(ui.context);
                if(search_model) {
                    search = search_model.get_search_configuration();
                }
            }
            var ids = [];
            if (has_dialog) {
                uly.publish("action.exec");
                action_resource.get_uri("uly:dialog").then(function(uri) {
                    var origin = ko.unwrap(ui.context && ui.context.inherit_parent_field);
                    var path = ko.unwrap(ui.context && ui.context.inherit_path);
                    var params = ko.unwrap(ui.context && ui.context.params);
                    //go up the stack to find inherit stuff
                    for (var i=0;i<=2;++i) {
                        if (!origin && !path && ui.context.$parents[i]) {
                            origin = ko.unwrap(ui.context.$parents[i].inherit_parent_field);
                            path = ko.unwrap(ui.context.$parents[i].inherit_path);
                        }
                    }
                    var target = ko.unwrap(ui.context && ui.context.target);
                    var dialog_data = params || undefined;
                    if (origin && path) {
                        dialog_data = {"origin":origin, "path":path, "target":target };
                        if (params) {
                            Object.assign(dialog_data, params);
                        }
                    }
                    return uly.dialogs.show(uri, {
                        before_close : function(result, button_pressed){
                            var post_data = $.extend({}, result, {"button_pressed":button_pressed});
                            if (search)
                                post_data = $.extend(post_data, { "search": search });
                            var res = action_resource.post("uly:submit", post_data);
                            return res.then(function(data){
                                if (data.redirect) {
                                    uly.utils.ask_for_redirect(data);
                                    return {};
                                }
                                return data;
                            });
                        }
                    }, dialog_data);
                }).then(function([dialog_data, ui, button, server_result]) {
                    let id = null;
                    let type_ = null;

                    if (server_result) {
                        if (server_result.id && server_result.type_) {
                            id = server_result.id;
                            type_ = server_result.type_;
                        } else if (server_result.__unique_id && !server_result.type_) {
                            let toks = server_result.__unique_id.split("#");
                            id = toks[1];
                            type_ = toks[0];
                        }
                    } else {
                        if (!dialog_data.unique_id && dialog_data.entity)
                            dialog_data = dialog_data.entity;
                        if (dialog_data.id && dialog_data.type_) {
                            id = dialog_data.id;
                            type_ = dialog_data.type_;
                        } else if (dialog_data.unique_id || dialog_data.__unique_id) {
                            var toks = (dialog_data.unique_id || dialog_data.__unique_id).split("#");
                            type_ = toks[0];
                            id = toks[1];
                        }
                    }
                    if (id && type_) {
                        return uly.api
                            .start()
                            .follow("uly:data")
                            .follow("find", {"rel":ko.unwrap(type_), "max":0})
                            .follow("find", {"rel":ko.unwrap(id), fields:"title,id,unique_id"});
                    } else {
                        return dialog_data;
                    }
                }).then(function(result) {
                    result.__unique_id = result.unique_id;
                    def.resolve(result);
                    uly.publish("entity.modified", { "entities":result.__unique_id });
                    if (control_id) {
                        uly.publish("entity.created."+control_id, {"id":result.id, "title":result.title, "unique_id":result.__unique_id});
                    } else {
                        uly.publish("entity.created", {"id":result.id, "title":result.title, "unique_id":result.__unique_id});
                    }
                }, function(result) {
                    def.reject(result);
                    uly.utils.show_results(result);
                });
            } else {
                var post_data = {
                    "entities": ids
                };
                if (search) {
                    post_data.search = search;
                }
                action_resource.post("uly:submit", post_data).done(function(result) {
                    if (!result.__unique_id && result.entity)
                        result = result.entity;
                    def.resolve(result);
                    uly.publish("entity.modified", { "entities":result.__unique_id });
                    if (control_id) {
                        uly.publish("entity.created."+control_id, {"id":result.id, "title":result.title, "unique_id":result.__unique_id});
                    } else {
                        uly.publish("entity.created", {"id":result.id, "title":result.title, "unique_id":result.__unique_id});
                    }
                }).always(uly.utils.show_results);
            }
        }).fail(def.reject);
        return def;
    },
    "create_child_entity_action": function(ev, $elt, ui, dialog_name, path, target_entity) {
        var def = Promise.Deferred();
        var action_resource = HalResource(ui.model);
        var entity_model = uly.utils.get_bound_entity($elt);
        if (ui.unique_id || !entity_model) {
            if (ui.unique_id) {
                entity_model = uly.api.fetch_entity(ui.unique_id);
            }
        } else {
            var def = Promise.Deferred();
            def.resolve(entity_model);
            entity_model = def;
        }
        if (!entity_model) {
            def.reject(null);
            return def;
        }
        return entity_model.then(function(entity_model) {
            var action = ui.model;
            if (!Array.isArray(entity_model)) {
                entity_model = [entity_model];
            }
            var ids = $.map(entity_model, function(value,idx) {
                if (value.content_type == "collection")
                    return ko.unwrap(value.type);
                return ko.unwrap(value.unique_id);
            });
            if (ids && ids.length > 0)
                ids = ids[0];

            var dialog_data = {

            };
            if (ui.initial_data) {
                $.extend(dialog_data, ui.initial_data);
            }
            return action_resource.get_uri("uly:dialog").then(function(uri) {
                return uly.dialogs.show(uri, {
                    before_close : function(result, button_pressed){
                        var post_data = $.extend({}, result, {"button_pressed":button_pressed});
                        var res = action_resource.post("uly:submit", post_data);
                        res.then(function(data){
                            if (data.redirect)
                                return uly.utils.ask_for_redirect(data);
                            return null;
                        });
                        return res;
                    }
                },$.extend(dialog_data, {
                    "origin":ids,
                    "path":ko.unwrap(path),
                    "target":ko.unwrap(target_entity)
                })).then(function(result) {
                    def.resolve(result);
                    uly.publish("entity.modified", { "entities":entity_model });
                }).fail(function(result) {
                    //def.reject(result)
                    uly.utils.show_results(result);
                });
            }).fail(function(error) {
                uly.utils.show_results(error);
            });
        });
    },
    actDelete: function(ev, $elt, ui) {
        //legacy action. not used anymore
        var action_resource = HalResource(ui.model);
        var dialog_data = {};
        var entity_model = ui.entity_model ? ui.entity_model : uly.utils.get_bound_entity($elt);
        var action = ui.model;
        if (!Array.isArray(entity_model)) {
            entity_model = [entity_model];
        }
        var ids = $.map(entity_model, function(value,idx) {
            return ko.unwrap(value.unique_id);
        });

        if (ids.length > 0) {
            uly.dialogs.ask_user(_("data_actions_confirm_deletion", "Confirm deletion"), _("data_actions_really_delete_entity", "Really delete entity?"), _("data_actions_yes", "Yes"), _("data_actions_no", "No")).done(function() {
                HalResource(entity_model[0]).delete("self").done(function() {
                    uly.publish("entity.deleted", entity_model);
                }).fail(uly.utils.show_results);
            });
        }
    },
    delete_entity: function(ev, $elt, ui) {
        var def = Promise.Deferred();
        uly.dialogs.ask_user(
            _("data_actions_confirm_deletion", "Confirm Deletion"),
            _("data_actions_are_you_sure_you_want_to_delete_this_entity", "Are you sure you want to delete this entity!?"),
            _("data_actions_yes", "Yes"),
            _("data_actions_no", "No")
        ).done(function() {
            uly.actions.standard_action(ev, $elt, ui).done(function(result) {
                if (result.success && uly.page.page_resource().unique_id && uly.page.page_resource().unique_id == uly.utils.get_bound_entity_id($elt))
                    history.go(-1);
            }).fail(def.reject);
        }).fail(function(){
            def.reject({
                "success":false,
                "error":_("data_actions_error_deletion_cancelled", "deletion cancelled")
            });
        });
        return def.promise();
    }
});
